export const ClientAutorisationStatus = {
   CERTIFIED: 'CERTIFIED',
   NOTCERTIFIED: 'NOTCERTIFIED',
   REVOKED: 'REVOKED',
   INTERNE: 'INTERNE',
} as const;

export type ClientAutorisationStatusValues = typeof ClientAutorisationStatus[keyof typeof ClientAutorisationStatus];

export enum FrenchClientAutorisationStatus {
   CERTIFIED = 'Certifié',
   NOTCERTIFIED = 'Non certifié',
   REVOKED = 'Révoqué',
   INTERNE = 'Interne'
}

export function takeEnumFrenchValue(value: ClientAutorisationStatusValues): string {
   switch (value) {
      case ClientAutorisationStatus.CERTIFIED:
         return FrenchClientAutorisationStatus.CERTIFIED;
      case ClientAutorisationStatus.NOTCERTIFIED:
         return FrenchClientAutorisationStatus.NOTCERTIFIED;
      case ClientAutorisationStatus.REVOKED:
         return FrenchClientAutorisationStatus.REVOKED;
      case ClientAutorisationStatus.INTERNE:
         return FrenchClientAutorisationStatus.INTERNE

   }
   return '';
}

export function takeEnumValue(value: any): string {
   switch (value) {
      case FrenchClientAutorisationStatus.CERTIFIED:
         return ClientAutorisationStatus.CERTIFIED;
      case FrenchClientAutorisationStatus.NOTCERTIFIED:
         return ClientAutorisationStatus.NOTCERTIFIED;
      case FrenchClientAutorisationStatus.REVOKED:
         return ClientAutorisationStatus.REVOKED;
      case FrenchClientAutorisationStatus.INTERNE:
         return ClientAutorisationStatus.INTERNE;
   }
   return '';
}

